import FlightDeckClient, {
  flightDeckUrlHttp,
  flightDeckUrlWs,
} from "@skydio/flight_deck_client_js/src/flight_deck";
import iot_management_pb from "@skydio/pbtypes/pbtypes/tools/cloud_api/iot_management_pb";

export const createFlightDeck = (
  config: iot_management_pb.WebTunnelConnectionInfo.AsObject,
  clientId: string,
  stateChangeCallback: (client: FlightDeckClient) => void
) => {
  const newClient = new FlightDeckClient(
    flightDeckUrlHttp(config),
    flightDeckUrlWs(config),
    clientId,
    config.credentials
  );
  newClient.setRequestHeaders(config.headersMap);
  newClient.addStateChangedCallback(stateChangeCallback);
  return newClient;
};
